import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import LiveTranscript from './LiveTranscript';
import routesfe from '../Config/RoutesFE';

const LiveTranscriptAccessWrapper = ({ user }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const access = params.get('access') || 'restricted';

  const isRestricted = access === 'restricted';

  if (isRestricted && !user) {
    return <Navigate to={routesfe.LOGIN} state={{ from: location }} replace />;
  }

  return <LiveTranscript />;
};

export default LiveTranscriptAccessWrapper;